import { useEffect, useState } from "react";
import GetFetch from "../hooks/GetFetch";
import PutPostPatchFetch from "../hooks/PutPostPatchFetch";
import { ROUTE_REGIONAL_SETTINGS } from "../routes/Routes";
import CustomPreparedHeaderCell from "../components/CustomPreparedHeaderCell";
import usePageTitle from "../hooks/usePageTitle";
import { RowExpander } from "../components/RowExpander/RowExpander";
import { Button } from "devextreme-react";
import { useAuth } from "../hooks/useAuth";
import ListViewConfig from "../ListViewConfig/ListViewConfig";
import { showNotification } from "../util/_helpers";

const InflationAdjustment = () => {
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const { title } = ROUTE_REGIONAL_SETTINGS;
    const { user } = useAuth();
    const { Regions } = user;

    usePageTitle(title);

    useEffect(() => {
        getRecords();
    }, []);

    const getRecords = async () => {
        setLoading(true);
        try {
            const { Errors, Message, Success } = await GetFetch('/v1/Region/GetSettingsAllRegions');
            if (Success)
                setDataSource(
                    Message.map(item =>  (
                        {
                            ...item, 
                            RegionalSettings: {
                                ...item.RegionalSettings[0], 
                                RegionNumber: item.RegionNumber, 
                                InflationRate: item.RegionalSettings[0].InflationRate
                            }
                        }
                    )).filter(obj => Regions.includes(obj['RegionNumber']))
                );
    
            if (Errors.length > 0) console.error(Errors);
        }
        catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const handleFormSubmission = async (e) => {
    /* if (!validateChanges(e.changes)) {
            e.cancel = true; // Prevent saving if validation fails
            return;
        } */
        const { Errors, Success } = await PutPostPatchFetch(
            "/v1/Region/UpdateSettingsByRegion",
            "POST",
            {
                RegionNumber: e.oldData.RegionNumber,
                inflationRate: e.newData.InflationRate,   
            }
        );

        if (Success) {
            showNotification(
                `Region ${e.oldData.RegionNumber} was updated, successfully.`,
                true,
                4000,
                500
            );
            getRecords();
        };

        if (Errors.length > 0) 
            showNotification(
                `Region ${e.oldData.RegionNumber} was not successfully updated.\nReason: ${Errors[0]}`,
                true,
                4000,
                500
            );
    };

    const MasterDetailComponent = ({ data }) => {
        const masterDetailProps = {
            allowRowAdding: false,
            allowRowDeleting: false,
            allowRowUpdating: true,
            typeButtonName: "buttons",
            columns: [
                {
                    type: "buttons",
                    cellElement: <Button name="edit" />,
                    dataType: "string"
                },
                {
                    caption: "Id",
                    dataField: "Id",
                    visible: false
                },
                {
                    alignment: "left",
                    caption: "Region",
                    dataField: "RegionNumber",
                    allowEditing: false
                },
                {
                    caption: "Inflation Rate",
                    dataField: "InflationRate",
                    dataType: "number",
                    calculateDisplayValue: ({ InflationRate}) => { return `${InflationRate}%` },
                    rangeRuleMessage: "Inflation Rate must be between 8 - 15%.", 
                    rangeRuleMin: 8.0,
                    rangeRuleMax: 15.0,
                    rangeRuleReevaluate: true,
                    requiredRuleMessage: "Inflation Rate is required."
                },
                {
                    caption: "Created By",
                    dataField: "CreatedBy",
                    allowEditing: false
                },
                {
                    caption: "Created Date",
                    dataField: "CreatedDate",
                    dataType: "date",
                    allowEditing: false   
                },
                {
                    caption: "Updated By",
                    dataField: "UpdatedBy",
                    allowEditing: false      
                },
                {
                    caption: "Updated Date",
                    dataField: "UpdatedDate",
                    dataType: "date",
                    allowEditing: false
                }
            ],
            dataSource: [ data.data.RegionalSettings ],
            enablePaging: false,
            enablePagerSizing: false,
            filterRow: false,
            keyExpr: "Id",
            isChild: true,
            rangeRuleMax: 14,
            rangeRuleMin: 8,
            rangeRuleReevaluate: true,
            rangeRuleMessage: "foo bar",
            onCellPrepared: CustomPreparedHeaderCell,
            onRowUpdating: handleFormSubmission,
        };

        return <ListViewConfig { ...masterDetailProps } />;
    };

    const childProps = {
        columns: [
            {
                cellRender: (data) => RowExpander(data,"RegionNumber"),
                type: "detailExpand",
            },
            {
                alignment: "left",
                caption: "Region",
                dataField: "RegionNumber",
            },
            {
                caption: "Zone",
                dataField: "Zone"          
            },
            {
                alignment: "left",
                caption: "Office Location",
                dataField: "OfficeLocation"
            },
            {
                caption: "Area Of Responsibility",
                dataField: "AreaOfResponsibility"
            }
        ],
        dataSource,
        filterRow: true,
        enablePaging: false,
        enablePagerSizing: false,
        isChild: false,
        keyExpr: "RegionNumber",
        loadingIndicatorState: loading,
        loadingIndicatorLocationId: "List-View",
        loadingIndicatorMessage: `Loading ${ title }. Please wait...`,
        masterDetailComponent: MasterDetailComponent,
        masterDetailEnabled: true,
        permissions: false, // no permissions settings for this module
        showSearchPanel: true,
        showToolBar: true,
        title
    };

    return <ListViewConfig {...childProps} />;

};

export default InflationAdjustment;